import React, { useRef, useEffect } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './dropdown.module.scss';

const DropdownOption = ({
  isActive,
  selected,
  onClick,
  id,
  searchResult,
  children,
  ...props
}) => {
  const optionRef = useRef();
  useEffect(() => {
    isActive && optionRef.current.focus();
  }, [isActive, optionRef]);

  const handleClick = (e) => {
    if (e.key === 'Enter') onClick();
  };

  return (
    <li className={styles.option}>
      <button
        id={id}
        tabIndex={-1}
        type="button"
        ref={optionRef}
        onKeyDown={handleClick}
        onClick={onClick}
        // eslint-disable-next-line react/prop-types
        className={cn(props.className, {
          [styles.selected]: selected,
          [styles.active]: isActive,
          [styles.searchResult]: searchResult,
        })}
      >
        {children}
      </button>
    </li>
  );
};

DropdownOption.propTypes = {
  /** The ID of the element. Useful to select the element during testing. */
  id: PropTypes.string,
  /** Whether or not the dropdown is active */
  isActive: PropTypes.bool,
  /** Whether or not the option is selected */
  selected: PropTypes.bool,
  /** A callback function called when the option is selected */
  onClick: PropTypes.func,
  /** The contents of the option */
  children: PropTypes.any,
  /** Use the search result styles on the option */
  searchResult: PropTypes.bool,
};

DropdownOption.defaultProps = {
  isActive: undefined,
  selected: undefined,
  onClick: undefined,
  children: undefined,
  searchResult: false,
};
export default DropdownOption;
